
import { defineComponent } from 'vue'
import Text from './common/Text.vue'

export default defineComponent({
  components: {
    Text,
  },
  data() {
    return {
      demo: '',
    }
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    formattedHeader() {
      return this.$t('home.aboutPro.header').replace(/\n/g, '<br>')
    },
    formattedDesc() {
      return this.$t('home.aboutPro.desc').replace(/\n/g, '<br>')
    },
  },
  watch: {
    currentLanguage(newLang) {
      this.updateMediaSources(newLang)
    },
  },
  methods: {
    updateMediaSources(lang: string) {
      const assetLang = lang === 'jp' ? 'ja' : lang
      try {
        this.demo = require(`@/assets/pages/home/screens/demo4-about-pro-${assetLang}.png`)
      } catch (e) {
        this.demo = require('@/assets/pages/home/screens/demo4-about-pro-en.png')
      }
    },
  },
  created() {
    this.updateMediaSources(this.currentLanguage)
  },
})
